// extracted by mini-css-extract-plugin
export default {"text":"HistoryScreen_text__ZE4-S"};